import React from "react";
//loading view created using css
const Loading = () => {
  return (
    <div className="section section-center">
      <div className="loading"></div>
    </div>
  );
};

export default Loading;
